import { render, staticRenderFns } from "./TermsofService.vue?vue&type=template&id=48faac5f&"
import script from "./TermsofService.vue?vue&type=script&lang=js&"
export * from "./TermsofService.vue?vue&type=script&lang=js&"
import style0 from "./TermsofService.vue?vue&type=style&index=0&id=48faac5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.2_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_mctg2n46w6x4hapmredvbec2hm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports